// extracted by mini-css-extract-plugin
export default {"counterButton":"Counter_counterButton__CZXJo","buttonWrapper":"Counter_buttonWrapper__S9eMX"};